import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import '../styles/common.css';

function ChildBadges() {
  const [user, setUser] = useState(null);
  const [badges, setBadges] = useState({
    earned: [],
    available: []
  });
  const [selectedBadge, setSelectedBadge] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // 로그인 상태 확인
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');

    if (!token || !userData) {
      navigate('/child/login');
      return;
    }

    try {
      const parsedUser = JSON.parse(userData);
      if (parsedUser.type !== 'child') {
        navigate('/');
        return;
      }
      setUser(parsedUser);
      // fetchBadgesData(); // TODO: 실제 API 호출
      setLoading(false);
    } catch (error) {
      console.error('사용자 데이터 파싱 오류:', error);
      navigate('/child/login');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/');
  };

  // 예시 뱃지 데이터 (추후 API에서 가져올 예정)
  const availableBadges = [
    {
      id: 1,
      name: '첫 발걸음',
      icon: '👶',
      description: '첫 번째 미션을 완료하세요',
      condition: '미션 1개 완료',
      earned: false,
      progress: 0,
      total: 1
    },
    {
      id: 2,
      name: '꾸준함의 시작',
      icon: '🔥',
      description: '연속 7일 미션을 완료하세요',
      condition: '7일 연속 완료',
      earned: false,
      progress: 0,
      total: 7
    },
    {
      id: 3,
      name: '완벽주의자',
      icon: '⭐',
      description: '한 주 동안 모든 미션을 완료하세요',
      condition: '주간 100% 달성',
      earned: false,
      progress: 0,
      total: 1
    },
    {
      id: 4,
      name: '도토리 수집가',
      icon: '🌰',
      description: '100개의 도토리를 모으세요',
      condition: '도토리 100개 달성',
      earned: false,
      progress: 0,
      total: 100
    },
    {
      id: 5,
      name: '미션 마스터',
      icon: '🏆',
      description: '총 50개의 미션을 완료하세요',
      condition: '미션 50개 완료',
      earned: false,
      progress: 0,
      total: 50
    },
    {
      id: 6,
      name: '월간 챔피언',
      icon: '👑',
      description: '한 달 동안 85% 이상 달성하세요',
      condition: '월간 85% 이상 달성',
      earned: false,
      progress: 0,
      total: 1
    }
  ];

  const getProgressPercentage = (badge) => {
    return Math.min((badge.progress / badge.total) * 100, 100);
  };

  const getProgressColor = (percentage) => {
    if (percentage >= 100) return '#28a745';
    if (percentage >= 70) return '#ffc107';
    return '#6c757d';
  };

  if (!user) {
    return (
      <div className="page-container">
        <div className="card">
          <div style={{ textAlign: 'center', padding: '20px' }}>
            로딩 중...
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      {/* 헤더 */}
      <div className="page-header">
        <Link to="/child/dashboard" className="back-btn">← 뒤로가기</Link>
        <h1>🏆 뱃지</h1>
        <button onClick={handleLogout} className="btn btn-outline btn-sm">
          로그아웃
        </button>
      </div>

      <div className="page-content">
        {/* 요약 카드 */}
        <div className="summary-card">
          <div className="summary-content">
            <div className="summary-item">
              <div className="summary-icon">🏅</div>
              <div className="summary-info">
                <h3>획득한 뱃지</h3>
                <p className="summary-value">{badges.earned.length}개</p>
              </div>
            </div>
            <div className="summary-divider"></div>
            <div className="summary-item">
              <div className="summary-icon">🎯</div>
              <div className="summary-info">
                <h3>전체 뱃지</h3>
                <p className="summary-value">{availableBadges.length}개</p>
              </div>
            </div>
          </div>
        </div>

        {/* 뱃지 목록 */}
        <div className="badges-card">
          <h3>🏆 뱃지 컬렉션</h3>
          <div className="badges-grid">
            {availableBadges.map(badge => (
              <div
                key={badge.id}
                className={`badge-item ${badge.earned ? 'earned' : 'locked'}`}
                onClick={() => setSelectedBadge(badge)}
              >
                <div className="badge-icon">
                  {badge.earned ? badge.icon : '🔒'}
                </div>
                <div className="badge-info">
                  <h4>{badge.name}</h4>
                  <p>{badge.condition}</p>
                  {!badge.earned && badge.progress > 0 && (
                    <div className="progress-bar">
                      <div
                        className="progress-fill"
                        style={{
                          width: `${getProgressPercentage(badge)}%`,
                          backgroundColor: getProgressColor(getProgressPercentage(badge))
                        }}
                      ></div>
                    </div>
                  )}
                  {!badge.earned && badge.progress > 0 && (
                    <span className="progress-text">
                      {badge.progress}/{badge.total}
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 다가오는 뱃지 */}
        <div className="upcoming-card">
          <h3>🎯 다음 목표</h3>
          <p>더 많은 미션을 완료하고 뱃지를 모아보세요!</p>
          <div className="tips-list">
            <div className="tip-item">
              <span className="tip-icon">💡</span>
              <span>매일 미션을 완료하면 '꾸준함' 뱃지를 얻을 수 있어요</span>
            </div>
            <div className="tip-item">
              <span className="tip-icon">🌟</span>
              <span>완벽한 한 주를 만들면 특별한 뱃지를 받을 수 있어요</span>
            </div>
            <div className="tip-item">
              <span className="tip-icon">🔥</span>
              <span>도토리를 많이 모으면 수집가 뱃지를 얻을 수 있어요</span>
            </div>
          </div>
        </div>
      </div>

      {/* 뱃지 상세 모달 */}
      {selectedBadge && (
        <div className="modal-overlay" onClick={() => setSelectedBadge(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>뱃지 상세</h3>
              <button
                onClick={() => setSelectedBadge(null)}
                className="modal-close"
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="modal-badge-icon">
                {selectedBadge.earned ? selectedBadge.icon : '🔒'}
              </div>
              <h4>{selectedBadge.name}</h4>
              <p className="badge-description">{selectedBadge.description}</p>

              {selectedBadge.earned ? (
                <div className="earned-status">
                  <span className="status-icon">✅</span>
                  <span>획득 완료!</span>
                </div>
              ) : (
                <div className="progress-section">
                  <div className="progress-info">
                    <span>진행률: {selectedBadge.progress}/{selectedBadge.total}</span>
                    <span>{getProgressPercentage(selectedBadge).toFixed(0)}%</span>
                  </div>
                  <div className="modal-progress-bar">
                    <div
                      className="modal-progress-fill"
                      style={{
                        width: `${getProgressPercentage(selectedBadge)}%`,
                        backgroundColor: getProgressColor(getProgressPercentage(selectedBadge))
                      }}
                    ></div>
                  </div>
                  <p className="progress-hint">
                    {selectedBadge.total - selectedBadge.progress}개 더 필요해요!
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <style>{`
        .page-container {
          min-height: 100vh;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          padding-bottom: 20px;
        }

        .page-header {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          border-bottom: 1px solid rgba(255, 255, 255, 0.2);
          padding: 15px 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }


        .page-header h1 {
          margin: 0;
          color: #764ba2;
          font-size: 1.3rem;
          font-weight: bold;
        }

        .page-content {
          max-width: 600px;
          margin: 0 auto;
          padding: 20px;
        }

        .summary-card, .badges-card, .upcoming-card {
          background: white;
          border-radius: 15px;
          padding: 20px;
          margin-bottom: 20px;
          box-shadow: 0 4px 16px rgba(0,0,0,0.1);
        }

        .summary-content {
          display: flex;
          align-items: center;
        }

        .summary-item {
          display: flex;
          align-items: center;
          gap: 15px;
          flex: 1;
        }

        .summary-divider {
          width: 1px;
          height: 50px;
          background: #e9ecef;
          margin: 0 20px;
        }

        .summary-icon {
          font-size: 2.5rem;
          width: 60px;
          text-align: center;
        }

        .summary-info h3 {
          margin: 0 0 5px 0;
          color: #333;
          font-size: 1rem;
        }

        .summary-value {
          margin: 0;
          font-size: 1.8rem;
          font-weight: bold;
          color: #764ba2;
        }

        .badges-card h3, .upcoming-card h3 {
          color: #333;
          margin-bottom: 20px;
        }

        .badges-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 12px;
        }

        .badge-item {
          display: flex;
          align-items: center;
          gap: 15px;
          padding: 15px;
          border-radius: 12px;
          cursor: pointer;
          transition: all 0.2s;
          border: 2px solid transparent;
        }

        .badge-item.earned {
          background: linear-gradient(135deg, #ffeaa7 0%, #fdcb6e 100%);
          border-color: #fdcb6e;
        }

        .badge-item.locked {
          background: #f8f9fa;
          border-color: #e9ecef;
        }

        .badge-item:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        }

        .badge-icon {
          font-size: 2.5rem;
          width: 50px;
          text-align: center;
        }

        .badge-info {
          flex: 1;
        }

        .badge-info h4 {
          margin: 0 0 5px 0;
          color: #333;
          font-size: 1.1rem;
        }

        .badge-info p {
          margin: 0 0 10px 0;
          color: #666;
          font-size: 0.9rem;
        }

        .progress-bar {
          width: 100%;
          height: 6px;
          background: #e9ecef;
          border-radius: 3px;
          overflow: hidden;
          margin-bottom: 5px;
        }

        .progress-fill {
          height: 100%;
          border-radius: 3px;
          transition: width 0.3s;
        }

        .progress-text {
          font-size: 0.8rem;
          color: #666;
          font-weight: 500;
        }

        .upcoming-card p {
          color: #666;
          margin-bottom: 20px;
        }

        .tips-list {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .tip-item {
          display: flex;
          align-items: flex-start;
          gap: 10px;
          padding: 12px;
          background: #f8f9fa;
          border-radius: 8px;
        }

        .tip-icon {
          font-size: 1.2rem;
          margin-top: 2px;
        }

        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }

        .modal-content {
          background: white;
          border-radius: 15px;
          width: 90%;
          max-width: 400px;
          max-height: 90vh;
          overflow-y: auto;
        }

        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px;
          border-bottom: 1px solid #e0e0e0;
        }

        .modal-header h3 {
          margin: 0;
          color: #333;
        }

        .modal-close {
          background: none;
          border: none;
          font-size: 1.5rem;
          cursor: pointer;
          color: #666;
        }

        .modal-body {
          padding: 20px;
          text-align: center;
        }

        .modal-badge-icon {
          font-size: 4rem;
          margin-bottom: 15px;
        }

        .modal-body h4 {
          margin: 0 0 10px 0;
          color: #333;
          font-size: 1.3rem;
        }

        .badge-description {
          color: #666;
          margin-bottom: 20px;
        }

        .earned-status {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          padding: 15px;
          background: #d4edda;
          border-radius: 8px;
          color: #155724;
          font-weight: bold;
        }

        .status-icon {
          font-size: 1.2rem;
        }

        .progress-section {
          text-align: left;
        }

        .progress-info {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          font-size: 0.9rem;
          color: #666;
        }

        .modal-progress-bar {
          width: 100%;
          height: 10px;
          background: #e9ecef;
          border-radius: 5px;
          overflow: hidden;
          margin-bottom: 15px;
        }

        .modal-progress-fill {
          height: 100%;
          border-radius: 5px;
          transition: width 0.3s;
        }

        .progress-hint {
          text-align: center;
          color: #666;
          font-size: 0.9rem;
          margin: 0;
        }

        @media (max-width: 480px) {
          .summary-content {
            flex-direction: column;
            gap: 20px;
          }

          .summary-divider {
            width: 100%;
            height: 1px;
            margin: 0;
          }

          .badge-item {
            flex-direction: column;
            text-align: center;
            gap: 10px;
          }
        }
      `}</style>
    </div>
  );
}

export default ChildBadges;